var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "card" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "card-body" }, [
        _c("div", { staticClass: "flex flex_gap_10 justify-content-between" }, [
          _c("div", { staticClass: "flex flex_gap_10 flex-wrap" }, [
            _c(
              "div",
              { staticClass: "flex-grow-1" },
              [
                _c("label", { attrs: { for: "" } }, [_vm._v("Дивизионы")]),
                _vm._v(" "),
                _c("multiselect", {
                  attrs: {
                    options: _vm.divisionsForSelect,
                    "track-by": "title",
                    label: "title",
                    "show-labels": false,
                    placeholder: "Любой дивизион",
                    multiple: true,
                  },
                  model: {
                    value: _vm.selectedDivisions,
                    callback: function ($$v) {
                      _vm.selectedDivisions = $$v
                    },
                    expression: "selectedDivisions",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", [
              _c("label", { attrs: { for: "" } }, [_vm._v("Интервал")]),
              _vm._v(" "),
              _c("div", [_c("DateRangePicker", { ref: "dateRange" })], 1),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("LoadingButton", {
                attrs: {
                  title: "Показать",
                  className: "btn btn-outline-info",
                  color: _vm.$constants.LOADING_COLOR,
                  loading: _vm.loadingBtn,
                  onClick: () => _vm.getRecords(),
                },
              }),
            ],
            1
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card" }, [
      _c(
        "div",
        { staticClass: "card-body" },
        [
          _c("pulse-loader", {
            staticClass: "text-center",
            attrs: {
              loading: _vm.loadingBtn && !_vm.records.length,
              color: _vm.$constants.LOADING_COLOR,
            },
          }),
          _vm._v(" "),
          _c("table", { staticClass: "table m-0 table-sm table-hover" }, [
            _vm._m(1),
            _vm._v(" "),
            _c(
              "tbody",
              _vm._l(_vm.records, function (r, i) {
                return _c("tr", [
                  _c("td", [
                    _vm._v(
                      _vm._s(
                        i +
                          1 +
                          (_vm.paginator.current_page - 1) *
                            _vm.paginator.per_page
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      _vm._s(
                        _vm.$AllDivisions[r.division_id]?.title ??
                          "Не определен дивизион"
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      "\n            " +
                        _vm._s(r.courier_name ?? "не назначен") +
                        "\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(r.project_label ?? "Не определен"))]),
                  _vm._v(" "),
                  _c("td", [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-xs btn-info ml-1 mr-2",
                        on: {
                          click: function ($event) {
                            return _vm.openOrderToEdit(r.id)
                          },
                        },
                      },
                      [_c("i", { staticClass: "icon-fa icon-fa-eye" })]
                    ),
                    _vm._v("\n            " + _vm._s(r.id) + "\n          "),
                  ]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(r.reject_comment))]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(_vm.printDate(r.report_date)))]),
                ])
              }),
              0
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            [
              _vm.paginator
                ? _c("paginate", {
                    attrs: {
                      "page-count": _vm.paginator.last_page,
                      "page-range": 8,
                      "margin-pages": 3,
                      "click-handler": _vm.getRecords,
                      "prev-text": "&laquo",
                      "next-text": "&raquo",
                      "container-class": "pagination",
                      "prev-class": "page-item",
                      "prev-link-class": "page-link",
                      "page-class": "page-item",
                      "page-link-class": "page-link",
                      "next-class": "page-item",
                      "next-link-class": "page-link",
                      "active-class": "active green_btn",
                    },
                    model: {
                      value: _vm.paginator.current_page,
                      callback: function ($$v) {
                        _vm.$set(_vm.paginator, "current_page", $$v)
                      },
                      expression: "paginator.current_page",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h5", [_vm._v("Отказы у курьеров")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Дивизион")]),
        _vm._v(" "),
        _c("th", [_vm._v("Курьер")]),
        _vm._v(" "),
        _c("th", [_vm._v("проект")]),
        _vm._v(" "),
        _c("th", [_vm._v("Заявка")]),
        _vm._v(" "),
        _c("th", [_vm._v("Отказ")]),
        _vm._v(" "),
        _c("th", [_vm._v("Дата")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }